var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MemberAccess',{attrs:{"loadingProp":_vm.loading,"usersProp":_vm.users,"invitedProp":_vm.invited,"memberAccessTypeProp":3,"changeOwnerEnabledProp":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }